import { Injectable } from '@angular/core';
import { Table } from 'dexie';
import { HubspotCompany } from '../models/hubspot-company.model';
import { DexieDatabaseBase } from './dexie-hardening';

export interface HubspotCompanyMeta {
  key: string;
  value: string;
}

@Injectable({ providedIn: 'root' })
export class HubspotCompanyDatabase extends DexieDatabaseBase {
  companies!: Table<HubspotCompany, string>;
  meta!: Table<HubspotCompanyMeta, string>;

  constructor() {
    super('NexusHubspotCompanyDB');
    this.version(1).stores({
      companies: 'hubspotId, name, netsuiteId',
      meta: 'key',
    });

    this.version(2)
      .stores({
        companies: 'hubspotId, name',
        meta: 'key',
      })
      .upgrade((transaction) =>
        transaction
          .table<HubspotCompany & { netsuiteId?: string }, string>('companies')
          .toCollection()
          .modify((company) => {
            delete company.netsuiteId;
          }),
      );
  }
}
